export const SITE = {
  name: "Tuft and Tale",
  tagline: "Your ideas, beautifully tufted.",
  whatsappNumber: "917034114400",
  whatsappDisplay: "+91 70341 14400",
  waGenericMessage:
    "Hi Tuft and Tale! I'd like to enquire about a custom rug.",
};

export function waLink(message: string): string {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
}
